import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Box, Mail, Eye, MessageSquare } from "lucide-react";

export default function AdminOverview() {
  const [products, setProducts] = useState([]);
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/products"), api.get("/admin/contact")])
      .then(([p, m]) => {
        setProducts(p.data);
        setMessages(m.data);
      })
      .catch(() => {});
  }, []);

  const unread = messages.filter((m) => !m.is_read).length;
  const stats = [
    { icon: Box, label: "Toplam Ürün", value: products.length, color: "text-[#059669]" },
    { icon: Mail, label: "Yeni Mesajlar", value: unread, color: "text-amber-500" },
    { icon: MessageSquare, label: "Tüm Mesajlar", value: messages.length, color: "text-emerald-500" },
    { icon: Eye, label: "Öne Çıkan Ürün", value: products.filter((p) => p.is_featured).length, color: "text-purple-500" },
  ];

  return (
    <div data-testid="admin-overview" className="p-8">
      <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#059669] mb-2">Yönetim Paneli</p>
      <h1 className="font-display text-3xl md:text-4xl tracking-tighter font-black">Genel Bakış</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        {stats.map((s) => (
          <div key={s.label} className="border border-gray-200 bg-white p-6">
            <s.icon size={22} className={s.color} />
            <p className="font-display text-4xl tracking-tighter font-black mt-4">{s.value}</p>
            <p className="text-[11px] uppercase tracking-[0.18em] text-gray-500 mt-1">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="border border-gray-200 bg-white mt-8">
        <div className="px-6 py-4 border-b border-gray-200">
          <p className="font-display text-lg tracking-tight">Son Mesajlar</p>
        </div>
        <div className="divide-y divide-gray-100">
          {messages.slice(0, 8).map((m) => (
            <div key={m.id} className="px-6 py-3 text-sm flex items-start justify-between gap-4">
              <div className="min-w-0">
                <p className="font-semibold">{m.name} <span className="text-gray-400 font-normal">· {m.email}</span></p>
                <p className="text-gray-500 text-xs truncate">{m.subject || m.message}</p>
              </div>
              <span className="text-[10px] font-mono-fd text-gray-400 whitespace-nowrap">
                {new Date(m.created_at).toLocaleDateString("tr-TR")}
              </span>
            </div>
          ))}
          {messages.length === 0 && (
            <div className="px-6 py-8 text-center text-gray-400 text-sm">Henüz mesaj yok</div>
          )}
        </div>
      </div>
    </div>
  );
}
